import type { FileStatus } from "@/types/files";

export interface GetImageFromRemoteResponse {
  fileId: string;
  mediaType: "image" | "video";
  status: FileStatus;
  message: string;
}

export function useRemoteImageDownload() {
  const { mutateAsync, mutate, isPending, isError } = useMutation({
    mutationFn: async (link: string) => {
      const { data } = await usePutRequest<GetImageFromRemoteResponse>(
        "/content/download-media-asset",
        {
          link,
        }
      );
      return data;
    },
  });

  return {
    mutateAsync,
    isPending,
    isError,
    getImage: mutate,
  };
}
